import { ChangeDetectionStrategy, Component } from '@angular/core';

interface PaymentLogo {
  readonly file: string;
  readonly alt: string;
  readonly width: number;
}

/// Yalnız `SHOW_PAYMENT_LOGOS` açıkken alt bilgide çizilir; dosyalar
/// (assets/site/payment/*) bayrak açılırken eklenmeli (alt proje B).
const PAYMENT_LOGOS: readonly PaymentLogo[] = [
  { file: 'paytr.svg', alt: 'PayTR', width: 72 },
  { file: 'visa.svg', alt: 'Visa', width: 58 },
  { file: 'mastercard.svg', alt: 'Mastercard', width: 38 },
  { file: 'troy.svg', alt: 'Troy', width: 52 },
];

@Component({
  selector: 'site-payment-logos',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div data-test="payment-logos">
      <p class="sr-only">Ödeme kuruluşu ve kart logoları</p>
      <ul role="list" class="flex flex-wrap items-center gap-[1rem]">
        @for (logo of logos; track logo.file) {
          <li>
            <img
              [src]="'assets/site/payment/' + logo.file"
              [alt]="logo.alt"
              [width]="logo.width"
              height="24"
              loading="lazy"
              class="h-6 w-auto"
            />
          </li>
        }
      </ul>
    </div>
  `,
})
export class PaymentLogosComponent {
  readonly logos = PAYMENT_LOGOS;
}
